export default __webpack_public_path__ + "static/media/group-14.5521b4b4.png";